import React, { memo, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import DashboardQuickLinksCard from 'Pages/InnerPages/DashBoard/DashQuicklinks/DashboardQuicklinksCard';
import BBPS_LOGO from 'Assets/Images/bbpslogo.jpg';
export const SDKLinks = (props) => {
    const location = useLocation();
    let params = new URLSearchParams(location?.search);
    let URL = params.get('URL');
    localStorage.setItem('OutsideToken', URL);
    const BBPSLogo = () => {
        return <BBPSLogoImage />;
    };

    const BBPSLogoImage = () => {
        return (
            <img
                src={BBPS_LOGO}
                height={25}
                width={90}
                style={{
                    float: 'right'
                }}
                alt="BBPS"
            />
        );
    };

    return (
        <div className="dashrechargepanel equalheight">
            <h3 className="text-center border-bottom pb-2 dashheading">
                <BBPSLogo />
            </h3>
            <section className="maincardbg mb-5">
                <div className="container-fluid mt-5">
                    <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-5 col-xl-5 mb-5">
                            <div className="col-sm-12 col-md-12 col-lg-5 col-xl-5 mb-5">
                                <DashboardQuickLinksCard
                                    link="/SDKTransaction"
                                    upperText="Transaction"
                                    lowerText="BBPS"
                                    bgColor="#193282"
                                    hoverColor="#f47920"
                                    imagePath={require('Assets/Images/TransactionHistory.svg')}
                                />
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-5 col-xl-5 mb-4">
                                <DashboardQuickLinksCard
                                    link="/SDKReport"
                                    upperText="Report"
                                    lowerText="Last10Report"
                                    bgColor="#f47920"
                                    hoverColor="#fdb834"
                                    imagePath={require('Assets/Images/AccountLedger.svg')}
                                />
                            </div>

                            <div className="col-sm-12 col-md-12 col-lg-5 col-xl-5 mb-5">
                                <DashboardQuickLinksCard
                                    link="/SDKComplaint"
                                    upperText="BBPS"
                                    lowerText="Complaint"
                                    bgColor="#b52323"
                                    hoverColor="#193282"
                                    imagePath={require('Assets/Images/PurchaseHistory.svg')}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};
